import { render, staticRenderFns } from "./ProgrammaticTargetBidSettings.vue?vue&type=template&id=50080f38"
import script from "./ProgrammaticTargetBidSettings.vue?vue&type=script&lang=js"
export * from "./ProgrammaticTargetBidSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports